<template>
  <div>
    <div class="card px-2 py-3 shadow-sm d-flex">
      <div class="row">
      <div class="col-md-3">
        <date-picker
          id="startDatePicker"
          class=""
          v-model="filterMonth"
          :config="datePickerConfig"
          placeholder="Start Date"
        ></date-picker>
      </div>

      <!-- Select users bdr -->
      <div class="col-md-2">
        <select
          v-model="bdr_user_id"
          class="form-control"
          @change="changeBDR"
          v-if="!userBdrsLoaded && userBdrs.length > 1"
        >
          <option :key="'a1'" :value="1">{{ $t("lang.label.all") }}</option>
          <option v-for="(user, i) in userBdrs" :key="i" :value="user.id">
            {{ user.label }}
          </option>
        </select>
      </div>

      <div class="col-12 col-md-4">
        <button
          class="btn btn-success"
          @click="getData()"
          style="width: 100%"
          :disabled="loading"
        >
          <i class="icon-calendar-check-o mr-2"></i>
          <small>
            {{ $t("lang.button.filter") }}
          </small>
        </button>
      </div>
    </div>

      <!-- <div class="d-flex my-0">
          <div class="d-flex col-12  col-md-3">
            <span class="pt-2 ml-1 mr-2">Period:</span>
            <IndustrySearch
                :option_list="months"
                :default_values="monthSelected"
                :key="3"
                :multiple="false"
                @selected="selectMonth"
              />
          </div>
          <div class="d-flex col-12 col-md-3" v-if="!userBdrsLoaded && userBdrs.length > 1">
            <span class="pt-2 mr-2">BDR:</span>
              <IndustrySearch                
                :option_list="userBdrs"
                :default_values="userOliverSale"
                :key="3"
                :multiple="false"
                :isDisabled="savingOliverUser || isUserOliverSale"
                @selected="selectBDR"
              />
          </div>
           <div class="d-flex col-12 col-md-6 justify-content-end py-0 my-0" v-if="!loadingDataSale">
              <span class="mx-0 p-0" v-if="saleRankingData.total">
                <img                  
                  class="ml-1"
                  :src="logoRevenueRanking(saleRankingData.total)"
                  height="78px"                  
                /></span>
              <span class="mx-0" v-if="saleRankingData.avatar">
                 <img                  
                  class="ml-1 rounded-circle shadow"
                  :src="saleRankingData.avatar"
                  height="70px"                  
                />
              </span>
            </div>
        </div>         -->

            <!-- Meetings -->
            <div class="col-12 mt-4">
              <div class="row" v-if="meetings.length > 0">
                <div class="col-12">
                  <div class="row" >
                    <div class="col-3"
                      v-for="client in meetings" :key="client.id"
                    >

                      <!-- Muestro componente de cargando. -->
                      <div class="card" v-if="gettingDataClient">
                        <Loadingcircle  :paramloading="paramloading" />
                      </div>

                      <template v-else>
                        <div class="card text-center py-2" v-if="client.data.length > 0">
                          <Tooltip
                            :text="client.textoToTooltip"
                            :width="''"
                          >
                            <p class="cursor-pointer" @click="OpenModal(client.detail, client.label, client.description)">
                              {{  client.label }}
                              <i class="ml-1 icon-eye"></i>
                            </p>                     
                          </Tooltip>
                          
                          <p class="cursor-pointer" :class="compareTotals(client)"  @click="OpenModal(client.detail, client.label, client.description)">
                            <span class="h2 ">
                              {{ getTotal('currentMonth', client) }}
                            </span>
                            <span class="ml-2 h4">
                              <i :class="compareTotals(client, 'arrow')"></i>
                            </span>
                          </p>

                          <small>
                            {{ getDate('beforeMonth', client) }}
                            {{ getTotal('beforeMonth', client) }}</small>
                        </div>
                    </template>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Order Performances -->
            <div class="col-12 mt-3">
              <div class="row" v-if="performances.length > 0">
                <div class="col-12">
                  <div class="row" >
                    <div class="col-3"
                      v-for="performance in performances" :key="performance.id"
                    >

                      <!-- Muestro componente de cargando. -->
                      <div class="card" v-if="gettingDataPerformance">
                        <Loadingcircle  :paramloading="paramloading" />
                      </div>

                      <template v-else>
                        <div class="card text-center  py-2" v-if="performance.data.length > 0">
                          <Tooltip
                            :text="performance.textoToTooltip"
                            :width="''"
                          >
                            <p>{{  performance.label }}</p>                         
                          </Tooltip>
                          <p :class="compareTotals(performance)">
                            <span class="h3 ">
                              {{ getTotal('currentMonth', performance) }}
                            </span>
                            <span class="ml-2 h4">
                              <i :class="compareTotals(performance, 'arrow')"></i>
                            </span>
                          </p>

                          <small>
                            {{ getDate('beforeMonth', performance) }}
                            {{ getTotal('beforeMonth', performance) }}</small>
                        </div>
                    </template>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sales -->
            <div class="col-12 mt-3">
              <div class="row" v-if="sales.length > 0">
                <div class="col-12">
                  <div class="row" >
                    <div class="col-3"
                      v-for="sale in sales" :key="sale.id"
                    >

                      <!-- Muestro componente de cargando. -->
                      <div class="card" v-if="gettingDataSale">
                        <Loadingcircle  :paramloading="paramloading" />
                      </div>

                      <template v-else>
                        <div class="card text-center  py-2" v-if="sale.data.length > 0">
                          <Tooltip
                            :text="sale.textoToTooltip"
                            :width="''"
                          >
                            <p class="cursor-pointer" @click="OpenModal(sale.detail, sale.label, sale.description)">
                              {{  sale.label }}
                              <i v-if="sale.description" class="ml-1 icon-eye"></i>
                            </p>                         
                          </Tooltip>
                          <p class="cursor-pointer" :class="compareTotals(sale)"  @click="OpenModal(sale.detail, sale.label, sale.description)">
                            <span class="h3">
                              {{ getTotal('currentMonth', sale) }}
                            </span>
                            <span class="ml-2 h4">
                              <i :class="compareTotals(sale, 'arrow')"></i>
                            </span>
                          </p>

                          <small>
                            {{ getDate('beforeMonth', sale) }}
                            {{ getTotal('beforeMonth', sale) }}</small>
                        </div>
                    </template>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Problems -->
            <div class="col-12 mt-3">
              <div class="row" v-if="problems.length > 0">
                <div class="col-12">
                  <div class="row" >
                    <div class="col-3"
                      v-for="problem in problems" :key="problem.id"
                    >

                      <!-- Muestro componente de cargando. -->
                      <div class="card" v-if="gettingDataProblem">
                        <Loadingcircle  :paramloading="paramloading" />
                      </div>

                      <template v-else>
                        <div class="card text-center  py-2" v-if="problem.data.length > 0">
                          <Tooltip
                            :text="problem.textoToTooltip"
                            :width="''"
                          >
                            <p>{{  problem.label }}</p>                         
                          </Tooltip>
                          <p :class="compareTotals(problem)">
                            <span class="h3 ">
                              {{ getTotal('currentMonth', problem) }} h
                            </span>
                            <span class="ml-2 h4">
                              <i :class="compareTotals(problem, 'arrow')"></i>
                            </span>
                          </p>

                          <small>
                            {{ getDate('beforeMonth', problem) }}
                            {{ getTotal('beforeMonth', problem) }} <span v-if="getTotal('beforeMonth', problem)">h</span></small>
                        </div>
                    </template>

                    </div>
                  </div>
                </div>
              </div>
            </div>
    </div>
    <div class="card px-2 py-3 shadow-sm mt-4" v-if="(userOliverSale[0] != '0' && monthSelected[0] != '0') && gettingDataClient == false">
      <div class="col-12">
        <OrderPerformanceToSaleDashboard
          :tabId="'20'"
          :condition="'LowOperatingMargin'"
          :oliver_sale_id="userOliverSale[0]"
          :month="monthSelected[0]"
          :showTotals="true"
        />
      </div>
    </div>

  <!-- Modal show table -->
  <Modal name="list" v-if="itemDetail" :size="'60'" :max-width="'650'" >
    <ListDataSaleMetrics 
      :item="itemDetail"
      :itemLabel="itemLabel"
      :itemDescription="itemDescription"
      :userOliverSale="userOliverSale[0]"
      :month="monthSelected[0]"
    />
  </Modal>

  </div>
</template>

<script>
import moment from "moment";
import { usersService} from "@/_services";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import Loadingcircle from  "@/components/Common/Loadingcircle.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import OrderPerformanceToSaleDashboard from "@/components/Performances/OrderPerformanceToSaleDashboard.vue";
import Tooltip from "@/components/Common/Tooltip.vue";
import Modal from "@/components/Common/Modal.vue";
import ListDataSaleMetrics from "@/components/Performances/ListDataSaleMetrics.vue"
import { mapState} from "vuex";

export default {
  name: 'MontlyMetrics',
  components: {
    IndustrySearch,
    Loadingcircle,
    LoadingSpinner,
    OrderPerformanceToSaleDashboard,
    Tooltip,
    Modal,
    ListDataSaleMetrics
  },
  data() {
    return {
      bdr_user_id: null,
      datePickerConfig: {
        format: "YYYY-MMM",
        // useCurrent: false,
        viewMode: "months",
        minDate: moment().subtract(12, "month"),
        maxDate: moment().endOf("day"),
      },
      filterMonth: moment().format("YYYY-MMM"),
       revenue_ranking: [
        { id: 1, img: '1_novice_closer.png',label: 'Novice Closer', min: 0, max: 15000},
        { id: 2, img: '2_deal_maker.png',label: 'Deal Maker', min: 15001, max: 40000},
        { id: 3, img: '3_sales_navigator.png',label: 'Sales Navigator', min: 40001, max: 80000},
        { id: 4, img: '4_revenue_builder.png',label: 'Revenue Builder', min: 80001, max: 150000},
        { id: 5, img: '5_growth_catalyst.png',label: 'Growth Catalyst', min: 150001, max: 250000},        
        { id: 6, img: '6_campaign_master.png',label: 'Campaign Master', min: 250001, max: 400000},
        { id: 7, img: '7_lead_strategist.png',label: 'Lead Strategist', min: 400001, max: 600000},
        { id: 8, img: '8_deal_architech.png',label: 'Deal Architect', min: 600001, max: 900000},
        { id: 9, img: '9_revenue_guru.png',label: 'Revenue Guru', min: 900001, max: 1200000},
        { id: 10,img: '10_b2b_rainmaker.png', label: 'B2B Rainmaker', min: 1200001, max: 5200000},
      ],
      saleRankingData: null,
      loadingDataSale: true,
      itemLabel: false,
      itemDetail: false,
      itemDescription: false,
      gettingDataSale: false,
      gettingDataProblem: false,
      gettingDataPerformance: false,
      gettingDataClient: false,
      sales: [
        { 
          id: 'new_clients', 
          detail: "new_clients", 
          label: 'New clients', 
          data: [], 
          textoToTooltip: 'New clients signed.',
          description: 'Customers who have registered a first payment method in the selected month.'
        },
        { 
          id: 'new_orders', 
          detail: "new_orders", 
          label: 'New order (new client)', 
          data: [], 
          textoToTooltip: 'Total number of new orders sold to customers who have already had active orders on Oliverlist in the past.',
          description: "Orders that have gone to 'Preparing' status in the selected month and that the copywriting has been validated by Oliverlist. Apply for customers who have registered the first payment method in the selected month.",
        },
        { 
          id: 'total_orders', 
          detail: "new_orders_old_client", 
          label: 'New orders (old clients)', 
          data: [], 
          textoToTooltip: 'Total number of new orders sold to new customers.',
          description: "Orders that have gone to 'Preparing' status in the selected month and that the copywriting has been validated by Oliverlist. Apply for customers who have registered the first payment method in a previous month.",
        },
        { 
          id: 'avg_meeting_price', 
          detail: "avg_meeting_price", 
          label: 'AVG meeting price', 
          data: [], 
          textoToTooltip: 'Average price excluding tax of orders sold.'
        },
      ],
      problems: [
        { 
          id: 'avg_lcm', 
          label: 'AVG LCM', 
          data: [], 
          textoToTooltip: 'Average time to resolve an order that appears in the Low Cashable Margin list in the Performance view.'
        },
        { 
          id: 'avg_lom', 
          label: 'AVG LOM', 
          data: [], 
          textoToTooltip: 'Average time to resolve an order that appears in the Low Operating Margin list in the Performance view.'
        },
        { 
          id: 'avg_com', 
          label: 'AVG COM', 
          data: [], 
          textoToTooltip: 'Average time to resolve an order that appears in the Critical Cashable Margin list in the Performance view.'
        },
        { 
          id: 'avg_wac', 
          label: 'AVG WAC', 
          data: [], 
          textoToTooltip: 'Average time to resolve an order that appears in the Warning Available Contacts list in the Performance view.'
        },
      ],
      performances: [
        { 
          id: 'revenue', 
          label: 'Revenue', 
          data: [], 
          textoToTooltip: 'Total revenue generated excluding tax.'
        },
        { 
          id: 'revenue_orders', 
          label: 'Revenue / Orders', 
          data: [], 
          textoToTooltip: 'Total revenue generated excluding tax per order.'
        },
        { 
          id: 'meetings_orders', 
          label: ' Meetings / orders', 
          data: [], 
          textoToTooltip: 'Average number of appointments generated per order.'
        },
        { 
          id: 'conversion_rate', 
          label: 'Meetings / unique prospects (month)', 
          data: [], 
          textoToTooltip: 'Total number of appointments generated out of the total number of new contacts involved in orders.'
        },
      ],
      meetings: [
        { 
          id: 'total_meeting_active', 
          detail: "active_clients", 
          label: 'Total Meeting', 
          data: [], 
          textoToTooltip: 'Total number of customers whose orders have been active at least once.',
          description: 'Customers who had an active order in the selected month.'
        },
        { 
          id: 'total_avg_meeting_day', 
          detail: "paused_clients", 
          label: 'AVG meeting / day', 
          data: [], 
          textoToTooltip: 'Total number of customers who stopped all their orders.',
          description: 'Customers who went from active to standby status in the selected month.'
        },
        { 
          id: 'total_revenew', 
          detail: "recovery_clients", 
          label: 'Total revenew', 
          data: [], 
          textoToTooltip: 'Total number of customers who have gone into judicial recovery.',
          description: 'Customers who switched to Recovery status in the selected month.'
        },
        { 
          id: 'total_meeting_deleted', 
          detail: "deleted_clients", 
          label: 'Deleted clients', 
          data: [], 
          textoToTooltip: 'Total number of customers whose accounts have been deleted from Oliverlist.',
          description: 'Customers who switched to Deleted status in the selected month.'
        },
      ],
      paramloading: {
            width: '58px',
            height: '58px',
            color: '#5054EB'
      },
      userBdrsLoaded: false,
      savingOliverUser: false,
      userOliverSale: ["0"],
      userBdrs: [
          { id: "0", label: "All"}
      ],
      monthSelected: ["0"],
      currentMonth:  moment().month() + 1,
      months:[
        { id: "0", label: 'Select option...' },
        { id: "01", label: 'January' },
        { id: "02", label: 'February' },
        { id: "03", label: 'March' },
        { id: "04", label: 'April' },
        { id: "05", label: 'May' },
        { id: "06", label: 'June' },
        { id: "07", label: 'July' },
        { id: "08", label: 'August' },
        { id: "09", label: 'September' },
        { id: "10", label: 'October' },
        { id: "11", label: 'November' },
        { id: "12", label: 'December' },
      ],
      monthsWithData:[],
    };
  },

  created() {
    this.init()
    const currentoMonth = moment().month() + 1;
    this.months = this.months.filter( el => el.id  <= currentoMonth)
    this.getuserBdrs()
  },

  computed: {
    ...mapState({
      user: (state) => state.authentication.user,
    }),
    isUserOliverSale() {
      return (this.user.role_id == 1 && this.user.user_constraint_id == 2);
    },
    logoRevenueRanking() {
      return (total) => {
        const image = this.revenue_ranking.find(el => (Number(total) >= el.min && Number(total) <= el.max )).img
        return require(`@/assets/images/revene_ranking/mini/${image}`);
      };
    },
    compareTotals() {
      return (client, arrow = null) => {
        if(client.data && client.data.length > 0 ) {
          let currentTotal = null;
          let oldTotal = null;

          if (client.data.find(el => el.current_month == '1')){
            currentTotal = client.data.find(el => el.current_month == '1').total || 0
          }

          if (client.data.find(el => el.current_month == '0')){
            oldTotal = client.data.find(el => el.current_month == '0').total || 0
          }


          if(currentTotal == null || oldTotal == null) return ''

          if(arrow == 'arrow'){
            if(Number(currentTotal) > Number(oldTotal)) return 'fas fa-arrow-up'
            if(Number(currentTotal) < Number(oldTotal)) return 'fas fa-arrow-down'
            return ''
          } else {

            if(client.id == 'avg_lom' || client.id == 'avg_wac' ||  client.id == 'avg_com' || client.id == 'avg_lcm' || client.id == 'total_avg_meeting_day' || client.id == 'total_revenew' || client.id == 'total_meeting_deleted'){
              if(Number(currentTotal) > Number(oldTotal)) return 'text-danger'
              if(Number(currentTotal) < Number(oldTotal)) return 'text-success'
            } else {
              if(Number(currentTotal) > Number(oldTotal)) return 'text-success'
              if(Number(currentTotal) < Number(oldTotal)) return 'text-danger'
            }

          return ''
          }
        }
      }
    },
    getDate() {
      return (type, client) => {
        if(client.data && client.data.length > 0 ) {

          if( type == 'currentMonth'){
            if (client.data.find(el => el.current_month == '1')){
              const statsDate = client.data.find(el => el.current_month == '1').stats_date
              return moment(statsDate).format('MMM YY') + ' :';
            }

          } else {
            if (client.data.find(el => el.current_month == '0')){
              const statsDate = client.data.find(el => el.current_month == '0').stats_date
              return moment(statsDate).format('MMM YY') + ' :';
            }

          }
        }
      }
    },
    getTotal() {
      return (type, client) => {
        if(client.data && client.data.length > 0 ) {

          const valuesWithDecimal = [ 'revenue_orders', 'meetings_orders', 'conversion_rate']
          const valuesWithSimbolEuro = [ 'revenue_orders', 'revenue', 'avg_meeting_price']
          const valuesWithSimbolPercentage = [ 'conversion_rate']

          if( type == 'currentMonth'){
            if (client.data.find(el => el.current_month == '1')){
              const value = client.data.find(el => el.current_month == '1').total
              if(valuesWithDecimal.includes(client.id)){
                if (valuesWithSimbolEuro.includes(client.id)){
                  return (valuesWithSimbolEuro.includes(client.id)) ?  Number(value).toFixed(2) + ' €' : Number(value).toFixed(2)
                }

                if (valuesWithSimbolPercentage.includes(client.id)){
                  return (valuesWithSimbolPercentage.includes(client.id)) ?  Number(value).toFixed(2) + ' %' : Number(value).toFixed(2)
                }
                return Number(value).toFixed(2)
              } else {
                if (valuesWithSimbolEuro.includes(client.id)){
                  return (valuesWithSimbolEuro.includes(client.id)) ?  Number(value).toFixed(0) + ' €' : Number(value).toFixed(2)
                }

                if (valuesWithSimbolPercentage.includes(client.id)){
                  return (valuesWithSimbolPercentage.includes(client.id)) ?  Number(value).toFixed(0) + ' %' : Number(value).toFixed(2)
                }
                return Number(value).toFixed(0)
              }

            }

          } else {//Si el valor que quiero mostrar es el total de mes anterior al mes seleccionado.
            if (client.data.find(el => el.current_month == '0')){
              const value = (client.data.find(el => el.current_month == '0').total)
              if(value){
                if(valuesWithDecimal.includes(client.id)){
                  if (valuesWithSimbolEuro.includes(client.id)){
                    return (valuesWithSimbolEuro.includes(client.id)) ?  Number(value).toFixed(2) + ' €' : Number(value).toFixed(2)
                  }

                  if (valuesWithSimbolPercentage.includes(client.id)){
                    return (valuesWithSimbolPercentage.includes(client.id)) ?  Number(value).toFixed(2) + ' %' : Number(value).toFixed(2)
                  }

                  return Number(value).toFixed(2)
                } else {
                  if (valuesWithSimbolEuro.includes(client.id)){
                    return (valuesWithSimbolEuro.includes(client.id)) ?  Number(value).toFixed(0) + ' €' : Number(value).toFixed(2)
                  }

                  if (valuesWithSimbolPercentage.includes(client.id)){
                    return (valuesWithSimbolPercentage.includes(client.id)) ?  Number(value).toFixed(0) + ' %' : Number(value).toFixed(2)
                  }
                  return Number(value).toFixed(0)
                }
              }
            }
          }
        }
      }
    }
  },

  methods: {
    initData(){
      this.meetings.forEach( el => {el.data = []})
      this.performances.forEach( el => {el.data = []})
      this.problems.forEach( el => {el.data = []})
      this.sales.forEach( el => {el.data = []})
    },      
    OpenModal(item, label, description = null){
      const itemAvailable = ['active_clients', 'paused_clients', 'recovery_clients', 'deleted_clients', 'new_clients', 'new_orders', 'new_orders_old_client']
      if(itemAvailable.includes(item)) {
        this.itemDetail = item
        this.itemLabel = label
        this.itemDescription = description
        this.$nextTick(() => {
          this.$modal.show('list');
        });
      }      
    },
    selectBDR(value){
      this.initData()
      if(value.id != 0){
        if(this.monthSelected[0] != "0"){
          this.loadingDataSale = true
          this.getData()
          //this.getDataAboutThisSale(value.id)
        }
      }
    },
    getDataAboutThisSale(oliser_sale_id){
       usersService.getOliveSaleAllRevenue(oliser_sale_id)
          .then( res => {
            if (res.result){
              this.saleRankingData = res.result
            }
            this.loadingDataSale = false
          })
    },
    selectMonth(value){
      this.initData()
      if(value.id != 0){
        this.userOliverSale = ["0"],
        this.getuserBdrs(null, this.monthSelected[0])

      }
    },
    getData(){

      const yearMonth = moment(this.filterMonth).format('YYYY-MM')
      
      //Meetings
       this.gettingDataClient = true
       usersService.getBdrMonthlyMetrics("meetings", this.bdr_user_id, yearMonth)
          .then( res => {
            if (res.result){
              const data = res.result

              this.meetings[0].data = data.filter(el => el.label == 'total_meeting_active')
              this.meetings[1].data = data.filter(el => el.label == 'total_avg_meeting_day')
              this.meetings[2].data = data.filter(el => el.label == 'total_revenew')
              this.meetings[3].data = data.filter(el => el.label == 'total_meeting_deleted')

            }
            this.gettingDataClient = false
          })
          .catch( err => console.err(err))

    //    //Performances
    //    this.gettingDataPerformance = true
    //    usersService.getOliverSalesDashboard("performances", this.userOliverSale[0], this.monthSelected[0])
    //       .then( res => {
    //         if (res.result){
    //           const data = res.result

    //           this.performances[0].data = data.filter(el => el.label == 'revenue')
    //           this.performances[1].data = data.filter(el => el.label == 'revenue_orders')
    //           this.performances[2].data = data.filter(el => el.label == 'meetings_orders')
    //           this.performances[3].data = data.filter(el => el.label == 'conversion_rate')

    //         }
    //         this.gettingDataPerformance = false
    //       })
    //       .catch( err => console.err(err))

    //     //Sales
    //    this.gettingDataSale = true
    //    usersService.getOliverSalesDashboard("sales", this.userOliverSale[0], this.monthSelected[0])
    //       .then( res => {
    //         if (res.result){
    //           const data = res.result

    //           this.sales[0].data = data.filter(el => el.label == 'new_clients')
    //           this.sales[1].data = data.filter(el => el.label == 'new_orders')
    //           this.sales[2].data = data.filter(el => el.label == 'total_orders')
    //           this.sales[3].data = data.filter(el => el.label == 'avg_meeting_price')

    //         }
    //         this.gettingDataSale = false
    //       })
    //       .catch( err => console.err(err))

    //     // Problem resolving
    //     this.gettingDataProblem = true
    //     usersService.getOliverSalesDashboard("problems", this.userOliverSale[0], this.monthSelected[0])
    //         .then( res => {
    //           if (res.result){
    //             const data = res.result

    //             if(data.length > 0){
    //               this.problems[0].data = data.filter(el => el.label == 'avg_lcm')
    //               this.problems[1].data = data.filter(el => el.label == 'avg_lom')
    //               this.problems[2].data = data.filter(el => el.label == 'avg_com')
    //               this.problems[3].data = data.filter(el => el.label == 'avg_wac')
    //             }

    //           }
    //           this.gettingDataProblem = false
    //         })
    //         .catch( err => console.err(err))

    },
    init(){
        if(this.monthSelected[0] != '0'){
            this.getuserBdrs(null, this.monthSelected[0])
        }
    },
    getuserBdrs(complete = 0, month){
      this.userBdrsLoaded = true
      usersService.getBdrs()
      .then( res => {
        if(res.result.length > 0) {
          this.userBdrs = [{ id: "0", label: "Select option..."}, { id: "all", label: "All"}]
          const userBdrsWithlabel = res.result.map( el => ({ ...el, label: el.name}))
          this.userBdrs.push(...userBdrsWithlabel)
          this.userBdrsLoaded = false

        //   if(this.isUserOliverSale) {
        //     const findUserOliverSale = this.userBdrs.find(el => el.id == this.user.id)
        //     if(findUserOliverSale) {
        //       this.userOliverSale = [findUserOliverSale.id]
        //       this.getData()
        //     }
        //   }
        }        
      })
      .catch( err => console.err(err))
    },
  },
};
</script>
